if (!customElements.get('glow-quiz-slider')) {
  class GlowQuizSlider extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.mobileBreakpoint = 768;
      this.isSliderActive = false;
    }

    connectedCallback() {
      this.track = this.querySelector('.glow-quiz__grid');
      this.items = this.querySelectorAll('.glow-quiz__item');
      if (!this.track || this.items.length === 0) return;

      this.buildControls();
      this.handleResize = this.onResize.bind(this);
      this.handleTouchStart = this.onTouchStart.bind(this);
      this.handleTouchMove = this.onTouchMove.bind(this);
      this.handleTouchEnd = this.onTouchEnd.bind(this);

      window.addEventListener('resize', this.handleResize);
      this.onResize();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      this.unbindTouch();
    }

    buildControls() {
      this.nav = document.createElement('div');
      this.nav.classList.add('glow-quiz-slider__nav');
      this.nav.innerHTML = `
        <button class="glow-quiz-slider__btn glow-quiz-slider__btn--prev" aria-label="Previous">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
        </button>
        <button class="glow-quiz-slider__btn glow-quiz-slider__btn--next" aria-label="Next">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
        </button>
      `;
      this.btnPrev = this.nav.querySelector('.glow-quiz-slider__btn--prev');
      this.btnNext = this.nav.querySelector('.glow-quiz-slider__btn--next');
      this.btnPrev.addEventListener('click', () => this.prev());
      this.btnNext.addEventListener('click', () => this.next());
    }

    activate() {
      if (this.isSliderActive) return;
      this.isSliderActive = true;
      this.currentIndex = 0;

      this.track.classList.add('glow-quiz__grid--slider');
      this.items.forEach((item) => item.classList.add('glow-quiz__item--slide'));

      this.track.parentNode.insertBefore(this.nav, this.track);
      this.nav.style.display = '';

      this.bindTouch();
      this.goTo(0, false);
    }

    deactivate() {
      if (!this.isSliderActive) return;
      this.isSliderActive = false;

      this.track.classList.remove('glow-quiz__grid--slider');
      this.items.forEach((item) => {
        item.classList.remove('glow-quiz__item--slide');
      });
      this.track.style.transform = '';

      if (this.nav.parentNode) this.nav.parentNode.removeChild(this.nav);
      this.unbindTouch();
    }

    onResize() {
      if (window.innerWidth < this.mobileBreakpoint || this.items.length >= 4) {
        this.activate();
        this.goTo(this.currentIndex, false);
      } else {
        this.deactivate();
      }
    }

    getSlideWidth() {
      if (this.items.length === 0) return 0;
      const style = getComputedStyle(this.items[0]);
      return this.items[0].offsetWidth + parseFloat(style.marginRight || 0);
    }

    getVisibleCount() {
      if (window.innerWidth >= this.mobileBreakpoint) {
        document.querySelector('.glow-quiz-slider__nav').classList.add('glow-quiz-slider__nav--desktop');
          return 3;
          
      }
      return 1;
    }

    goTo(index, animate = true) {
      const visible = this.getVisibleCount();
      const max = Math.max(0, this.items.length - visible);
      this.currentIndex = Math.max(0, Math.min(index, max));

      const slideWidth = this.getSlideWidth();
      const offset = -(this.currentIndex * slideWidth);

      this.track.style.transition = animate ? 'transform 0.35s ease' : 'none';
      this.track.style.transform = `translateX(${offset}px)`;

      this.updateButtons();
    }

    next() {
      const visible = this.getVisibleCount();
      this.goTo(this.currentIndex + visible);
    }

    prev() {
      const visible = this.getVisibleCount();
      this.goTo(this.currentIndex - visible);
    }

    updateButtons() {
      const visible = this.getVisibleCount();
      const max = Math.max(0, this.items.length - visible);
      this.btnPrev.disabled = this.currentIndex === 0;
      this.btnNext.disabled = this.currentIndex >= max;
    }

    /* Touch / swipe support */
    bindTouch() {
      this.track.addEventListener('touchstart', this.handleTouchStart, { passive: true });
      this.track.addEventListener('touchmove', this.handleTouchMove, { passive: false });
      this.track.addEventListener('touchend', this.handleTouchEnd, { passive: true });
    }

    unbindTouch() {
      this.track.removeEventListener('touchstart', this.handleTouchStart);
      this.track.removeEventListener('touchmove', this.handleTouchMove);
      this.track.removeEventListener('touchend', this.handleTouchEnd);
    }

    onTouchStart(e) {
      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
      this.touchDeltaX = 0;
      this.isSwiping = false;
    }

    onTouchMove(e) {
      this.touchDeltaX = e.touches[0].clientX - this.touchStartX;
      const deltaY = Math.abs(e.touches[0].clientY - this.touchStartY);

      if (!this.isSwiping && Math.abs(this.touchDeltaX) > deltaY && Math.abs(this.touchDeltaX) > 5) {
        this.isSwiping = true;
      }

      if (this.isSwiping) {
        e.preventDefault();
        const slideWidth = this.getSlideWidth();
        const base = -(this.currentIndex * slideWidth);
        this.track.style.transition = 'none';
        this.track.style.transform = `translateX(${base + this.touchDeltaX}px)`;
      }
    }

    onTouchEnd() {
      if (!this.isSwiping) return;
      const threshold = 50;
      if (this.touchDeltaX < -threshold) {
        this.next();
      } else if (this.touchDeltaX > threshold) {
        this.prev();
      } else {
        this.goTo(this.currentIndex);
      }
    }
  }

  customElements.define('glow-quiz-slider', GlowQuizSlider);
}
